import { gql } from '@apollo/client';

export const RESOLVE_POST_REPORTS = gql`
  mutation resolvePostReports($postId: ID!, $verdict: VerdictKind!, $templateKey: ID!) {
    resolvePostReports(postId: $postId, verdict: $verdict, templateKey: $templateKey) {
      report {
        id
        status
        postId
        reporterId
        reason
        category
        details
        createdAt
        assignedModeratorId
        assignedAt
      }
      wsEventSent
      emailSent
    }
  }
`;
